import { combineReducers } from '@reduxjs/toolkit';
import AnalysisProjectSlice from './project.slice';
import AnalysisReportSlice from './report.slice';
import AnalysisModuleSlice from './module.slice';
import AnalysisPointsHistorySlice from './pointshistory.slice';
import AnalysisDashboardSlice from './dashboard.slice';

export const analysisRootReducer = combineReducers({
    dashboard: AnalysisDashboardSlice,
    project: AnalysisProjectSlice,
    report: AnalysisReportSlice,
    module: AnalysisModuleSlice,
    pointsHistory: AnalysisPointsHistorySlice
});
